import script from "./CancellationConfirm.vue?vue&type=script&setup=true&lang=ts"
export * from "./CancellationConfirm.vue?vue&type=script&setup=true&lang=ts"

import "./CancellationConfirm.vue?vue&type=style&index=0&id=74d6b60b&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74d6b60b"]])

export default __exports__